<template>
	<div :class="previewMode ? '' : 'wf-border wf-px-2 wf-py-1 wf-pt-0 wf-border-transparent hover:wf-border-gray-500 hover-trigger'">
    <div v-show="! previewMode" class="wf-relative wf-justify-end wf-flex">
      <button class="hover-target blog-posts-block-handle wf-text-gray-500"><i class="fas fa-arrows-alt"></i></button>
    </div>
		<h2 :class="classes" :style="styles" v-text="value"></h2>
	</div>
</template>

<script>
	import BlogPostsBlock from '../contracts/BlogPostsBlock'
  export default BlogPostsBlock.extend({})
</script>